module.exports = __webpack_public_path__ + "static/img/wariant3.281c7a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/urzadzenia/wariant3.png
// module id = BQp8
// module chunks = 1